/**
 * Created by intellicar-rinas on 22/12/17.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import './RightPane.css';
import Dom from '../../helpers/Dom';
import DialFlatView from './views/DialFlatView/DialFlatView';
import AppScreen from './views/AppScreen/AppScreen';
import CompactorView from './views/CompactorView2/CompactorView2';
import AjaxView1 from './views/AjaxView1/CompactorView';
import PaverView from './views/PaverView/PaverView';
import TPMSView from './views/TPMSView/TPMSView';
import ScooterView from './views/ScooterView/ScooterView';
import TorkView from './views/TorkView/TorkView';
import EtrioView from './views/EtrioView/EtrioView';
import TripDetails from './views/TripDetails';
import actions from '../../store/actions';
import _ from 'lodash';

class RightPane extends Component {

    state={
        gps:{},
        can:{},
        vehicle:null
    };

    config = {
        AppScreen:{
            key:'AppScreen',
        },
        CompactorView:{
            key:'CompactorView',
        },
        DialFlatView:{
            key:'DialFlatView',
        },
        PaverView:{
            key:'PaverView',
        },
        AjaxView1:{
            key:'AjaxView1',
        },
        TPMSView:{
            key:'TPMSView',
        },
        ScooterView:{
            key:'ScooterView',
        },
        TorkView: {
            key:'TorkView'
        },
        EtrioView: {
            key: 'EtrioView',
        },
        TripDetails: {
            key: 'TripDetails'
        },
    };

    constructor(){
        super();
        ['getView', 'isActive', 'onCAN', 'onCAN2', 'onGPS', 'onVehicleChange', 'onPhoneInfo'].map(i=>this[i]=this[i].bind(this));

        if(window.listenToMQTT) {
            window.listenToMQTT('CAN', this.onCAN, 'rightPane');
            window.listenToMQTT('CAN2', this.onCAN2, 'rightPane');
            window.listenToMQTT('GPS', this.onGPS, 'rightPane');
            window.listenToMQTT('PHONEINFO', this.onPhoneInfo, 'rightPane');
            window.listenToMQTT('USERGPS', this.onGPS, 'rightPane');
            window.addVehicleListener('rightPane', this.onVehicleChange);
        }
        window.onMarkerClicked = false
    }

    onCAN(msg){
        this.setState({can:msg, vehicle:window.selectedVehicle});
        let currentView = _.get(this.props, 'rightPane.view.key', 'DialFlatView');
        if(msg.ti) {
            this.props.dispatch({
                type: actions.RIGHT_PANE_VIEW_CHANGED,
                data: this.config.TripDetails
            });
            this.props.dispatch({ type:actions.RIGHT_PANE_TOGGLED, data: true});
        } else
        this.refs.view.updateView();
    }

    onCAN2(msg){
        this.setState({can2:msg, vehicle:window.selectedVehicle});
        this.refs.view.updateView();
    }

    onPhoneInfo(msg){
        this.setState({phoneInfo:msg, vehicle:window.selectedVehicle});
        this.refs.view.updateView();
    }

    onGPS(msg){
        this.setState({gps:msg, vehicle:window.selectedVehicle});
        this.refs.view.updateView();
    }

    isActive(){
        let active = this.props.rightPane && this.props.rightPane.active && (!this.props.reportWindow || !this.props.reportWindow.visible)
        if(window.onMarkerClicked && active) {
            console.log("calling active")
            setTimeout(() =>{
                window.callCmdBtnApi()

            },100)
        }
        return this.props.rightPane && this.props.rightPane.active && (!this.props.reportWindow || !this.props.reportWindow.visible);
    }

    getView(){
        let key = this.props.rightPane && this.props.rightPane.view ? this.props.rightPane.view.key : null;
        switch (key) {
            case this.config.AppScreen.key:
                return <AppScreen vehicle={()=>{return this.state.vehicle}} ref="view"/>

            case this.config.CompactorView.key:
                return <CompactorView vehicle={()=>{return this.state.vehicle}} ref="view"/>

            case this.config.PaverView.key:
                return <PaverView vehicle={()=>{return this.state.vehicle}} ref="view"/>

            case this.config.AjaxView1.key:
                return <AjaxView1 vehicle={()=>{return this.state.vehicle}} ref="view"/>

            case this.config.TPMSView.key:
                return <TPMSView vehicle={()=>{return this.state.vehicle}} ref="view"/>

            case this.config.ScooterView.key:
                return <ScooterView vehicle={()=>{return this.state.vehicle}} ref="view"/>

            case this.config.TorkView.key:
                return <TorkView vehicle={()=>{return this.state.vehicle}} ref="view"/>

            case this.config.EtrioView.key:
                return <EtrioView vehicle={() => this.state.vehicle} ref="view" data = {this.props} currentState={this.state}/>

            case this.config.TripDetails.key:
                if(_.get(this.state.vehicle, 'CAN.ti')) return <TripDetails vehicle={this.state.vehicle} ref="view" />

            default:
                return <DialFlatView vehicle={()=>{return this.state.vehicle}} ref="view"/>
        }
    }

    render() {
        return (
            <div className={Dom.Class({'active':this.isActive()}, "RightPane")}>
                {this.getView()}
            </div>
        )
    }

    onVehicleChange(selectedVehicle){
        if(this.refs.view && this.refs.view.clearState) {
            this.refs.view.clearState(()=>{
                this.setState({vehicle:selectedVehicle});
            });
        }else{
            this.setState({vehicle:selectedVehicle});
        }
        //
        let tempView = null;
        let key = this.props.rightPane && this.props.rightPane.view ? this.props.rightPane.view.key : null;
        let model = '';
        if(selectedVehicle.vehiclemeta && selectedVehicle.vehiclemeta.model) {
            model = selectedVehicle.vehiclemeta && selectedVehicle.vehiclemeta.model;
            model = model.trim().toLowerCase();
        }
        let groups = this.props.groupTree.children.map(f => f.path).filter(f => f);
        const etrioViewGroups = window.evGroups || [];
        if(selectedVehicle && selectedVehicle.tpmsconfig) {
            tempView = this.config.TPMSView.key;
        }else if(model === 'asphalt paver p5320'.trim().toLowerCase()) {
            tempView = this.config.PaverView.key;
        }else if(model === 'Compactor'.trim().toLowerCase()) {
            tempView = this.config.CompactorView.key;
        }else if(model === "agro2500".trim().toLowerCase()) {
            tempView = this.config.AjaxView1.key;
        }else if(model === 'TVS_POC') {
            tempView = this.config.ScooterView.key;
        }else if(model === 'TORK') {
            tempView = this.config.TorkView.key;
        }else if(etrioViewGroups.map(f => groups.filter(g => g.includes(f)).length > 0).includes(true)) {
            tempView = this.config.EtrioView.key;
        }else if(selectedVehicle.type === 'user') {
            tempView = this.config.AppScreen.key;
        } else {
            // tempView = this.config.DialFlatView.key;
            setTimeout(()=>{
                this.props.dispatch({ type:actions.RIGHT_PANE_TOGGLED, data:false});
            });
        }

        if(tempView != null && tempView !== key) {
            this.props.dispatch({
                type:actions.RIGHT_PANE_VIEW_CHANGED,
                data:this.config[tempView]
            })
        }
    }

    componentDidMount(){
        this.props.dispatch({
            type:actions.RIGHT_PANE_VIEW_CHANGED,
            data:this.config[Object.keys(this.config)[2]]
        })
    }

}

const mapPropsToState = state => {
    return {
        rightPane:state.rightPane,
        reportWindow:state.reportWindow,
        selectedVehicle:state.selectedVehicle,
        groupTree: state.groupTree,
    }
};

export default connect(mapPropsToState)(RightPane);